<div class="dialog">
    <div class="modal-header">
        <h4 class="modal-title" *ngIf="tabIndex === 0 && isAuthTask">Engine Check Auth Steps</h4>
        <h4 class="modal-title" *ngIf="tabIndex === 0 && !isAuthTask">Record an Engine Video</h4>
        <h4 class="modal-title" *ngIf="tabIndex === 1 && isAuthTask">Video of Engine for Auth</h4>
        <h4 class="modal-title" *ngIf="tabIndex === 1 && !isAuthTask">Record the Engine</h4>
        <h4 class="modal-title" *ngIf="tabIndex === 2">Engine recording saved</h4>
        <img class="modal-close" *ngIf="canClose" (click)="close()" alt="" />
    </div>
    <div class="modal-body">
        <div *ngIf="tabIndex === 0">
            <div class="instructions">
                <div *ngIf="isAuthTask">
                    When starting the video please make sure the reg is in view, the engine is off and the bonnet is open.
                    When taking the video please get as close as you can to the vehicle then start the engine.
                </div>
                <div *ngIf="!isAuthTask">
                    Capture a video of the engine to support accurate mechanical grading.
                    Once saved, the video will upload in the background and be available for review.
                </div>
                <br>
                <div *ngIf="isAuthTask">
                    The steps are on the following page
                </div>
                <br>
                <div *ngIf="isAuthTask" class="bold">
                    If any of the steps are missed the engine check authorisation will be declined.
                </div>
                <div *ngIf="!isAuthTask" class="bold">
                    Capture each step clearly and make sure the engine can be heard.
                </div>
            </div>
            <br>
        </div>
        <div *ngIf="tabIndex === 1">
            <div class="d-flex row">
                <div class="instructions col-8" *ngIf="isAuthTask && !attemptsExceeded">
                    <div>
                        1. Start the engine.
                    </div>
                    <br>
                    <div>
                        2. Allow to idle for 5-10 seconds.
                    </div>
                    <br>
                    <div>
                        3. Take revs to 3000rpm for 5-10 seconds.
                    </div>
                    <br>
                    <div>
                        4. Allow engine to return to idle.
                    </div>
                    <br *ngIf="isAuthTask">
                    <div *ngIf="isAuthTask">
                        5. With the video still running, move from the engine bay into the cabin and clearly show the
                        dashboard, hold the image on the dashboard for 3 seconds.
                    </div>
                    <br *ngIf="isAuthTask">
                    <div *ngIf="isAuthTask">
                        6. Ask the customer to rev the vehicle to 3,000 revs for 5-10 seconds and video exhaust emissions.
                    </div>
                </div>
                <div class="instructions col-8" *ngIf="isAuthTask && attemptsExceeded">
                    <div>
                        Video has failed to upload you will need to revert to the original Engine Check Auth process and take the video via WhatsApp.
                    </div>
                </div>
                <div class="instructions col-8" *ngIf="!isAuthTask">
                    <div class="bold">One continuous video • Minimum 15 seconds, plus engine start</div>
                    <br><br>
                    <div>Frame the engine bay clearly and make sure the engine can be heard.</div>
                    <br>
                    <div>1. Start recording before starting the engine.</div>
                    <br>
                    <div>2. Start the engine and idle for 5 seconds.</div>
                    <br>
                    <div>3. Hold at 3,000 rpm for 5 seconds.</div>
                    <br>
                    <div>4. Return to idle for 5 seconds, then stop.</div>
                </div>
                <div class="video col-4">
                    <app-video-input [group]="group" [quoteStateId]="quoteStateId" [isEngineCheck]="true" [backgroundUpload]="!isAuthTask">
                    </app-video-input>
                </div>
            </div>
            <div class="progress progress-bar-margin" [hidden]="!showProgressBar || attemptsExceeded">
                <div class="progress-bar bg-success"  [style.width.%]="currentUploadProgress" role="progressbar"></div>
            </div>
            <div class="completed-message" *ngIf="showCompletedMessage">
                Upload Completed
            </div>
        </div>
        <div *ngIf="tabIndex === 2">
            <div class="instructions">
                <div>
                    The video will upload automatically in the background. You don't need to wait for this to complete.
                </div>
                <br><br>
                <div class="bold">
                    You can continue with the purchase.
                </div>
            </div>
            <br>
        </div>
    </div>
    <div class="footer">
        <button type="button" *ngIf="tabIndex === 0" class="button-next button_green" (click)="loadVideoTab()">
            Next
        </button>
        <button type="button" *ngIf="tabIndex === 1" class="button-next send_button button_green modal-button"
            [ngClass]="{'loading': loading, 'upload-succeded': uploadSucceded || attemptsExceeded}"
            [disabled]="!isSendEnabled" (click)="sendVideo(uploadSucceded, attemptsExceeded)">
            Send
        </button>
        <button type="button" *ngIf="tabIndex === 2" class="button-next button_green" (click)="close()">
            Continue
        </button>
    </div>
</div>